import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import { formatarValorMonetario } from "../../../../../../../../../helpers/masks";

export default function DialogMemoriaCalculo({
  open,
  memoriaCalculo,
  onClose
}: DialogMemoriaCalculoProps) {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        Memória de cálculo
      </DialogTitle>
      <DialogContent>

        <TableContainer>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell><strong>Data</strong></TableCell>
                <TableCell><strong>Indice de juros</strong></TableCell>
                <TableCell><strong>Valor do movimento</strong></TableCell>
                <TableCell><strong>Valor da multa</strong></TableCell>
                <TableCell><strong>Saldo atualizado</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {memoriaCalculo.map((row: any) => (
                <TableRow
                  key={row.data}
                >
                  <TableCell>{moment(row.data).format('DD/MM/YYYY')}</TableCell>
                  <TableCell>{row.indice_juros}</TableCell>
                  <TableCell>{formatarValorMonetario(row.valor_movimento)}</TableCell>
                  <TableCell>{formatarValorMonetario(row.valor_multa ?? 0)}</TableCell>
                  <TableCell>{formatarValorMonetario(row.saldo_atualizado)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={onClose}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
interface DialogMemoriaCalculoProps {
  open: boolean;
  onClose: () => void
  memoriaCalculo: any
}

